import { useEffect, useRef, useState } from "react";
import HeaderPatientSearchIcon from "../../assets/svg/HeaderPatientSearchIcon";
import PatientSearch from "./PatientSearch";
import TriangleIcon from "../../assets/svg/TriangleIcon";

function TabletModePatientSearch() {
  const dropDownRef = useRef<any>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setIsOpen(false); // Close dropdown if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className=" lg:hidden w-full" ref={dropDownRef}>
      <button
        type="button"
        className="lg:hidden"
        onClick={() => setIsOpen((prevState) => !prevState)}
      >
        <HeaderPatientSearchIcon
          height={24}
          width={24}
          stroke={isOpen ? "#18B5B7" : undefined}
          className="mt-1"
        />
      </button>
      {isOpen && (
        <div className="w-[100vw] left-0 absolute z-[999999999] bg-white py-3 md:p-3 border shadow-lg mt-1">
          {/* <TriangleIcon className="absolute -top-3 right-[38vw] md:right-[175px]" /> */}
          <PatientSearch
            mode="dropdown"
            containerClassName="max-h-[36px] "
            closeInput={() => setIsOpen(false)}
          />
        </div>
      )}
    </div>
  );
}

export default TabletModePatientSearch;
